<div class="mainContainer">
    <h2>
        Que pensez-vous diffuser sur <ng-container *ngIf="nbrFaceSelected == 1">cet écran?</ng-container
        ><ng-container *ngIf="nbrFaceSelected != 1">ces {{ nbrFaceSelected }} écrans ?</ng-container>
    </h2>
    <div class="headTextContainer">
        <p>Maintenant que vous savez où et quand diffuser, qu'allez-vous diffuser?</p>
        <p>
            A la suite de votre achat, vous disposerez d'un espace personnel Wanview vous permettant de paramétrer vos
            diffusions du <strong style="color: #c10c4c">{{ campaignStartDate | date: 'dd/MM/YY' }}</strong> au
            <strong style="color: #c10c4c">{{ campaignEndDate | date: 'dd/MM/YY' }}</strong>
            <!-- <i style=" margin-left: 7px; font-size: 12px;">(en fonction de dates, jour de semaine, horaires, météo, etc...)</i> -->
            .
        </p>
        <p style="margin-top: 30px"><strong>Avec Wanview, vous pourrez :</strong></p>
    </div>
    <div class="articleContainer">
        <div class="card">
            <h3>Importer vos contenus</h3>
            <!-- <div class="lottie" id="uploadVideo"></div> -->
            <div class="iframeContainer">
                <iframe src="https://lottie.host/embed/7e50677f-8782-4306-a0e9-536dc98541f2/nw7SUYWWwt.json"></iframe>
            </div>
            <p>
                Ajoutez directement vos élements (images et vidéos) dans votre espace et de
                les diffuser.
            </p>
        </div>
        <div class="card graphCard">
            <h3>Utiliser nos modèles d'animation</h3>
            <!-- <div class="lottie" id="editor"></div> -->
            <div class="iframeContainer">
                <iframe src="https://lottie.host/embed/4a278ecd-7062-4860-81a0-e67fc21df011/uXuILuuzLH.json" id="templateLottie"></iframe>
            </div>
            <p>
                Personnalisez un de nos nombreux modèles d'animations en y intégrant vos éléments, textes,
                prix, logo, label, etc ..
            </p>
            <button mat-raised-button (click)="showTemplate = !showTemplate" style="width: 100%">
                {{ showTemplate ? 'Voir moins' : 'Voir des exemples' }}
            </button>
            <div class="templateShow" [ngClass]="{ exampleSee: showTemplate }">
                <!-- autoplay="autoplay"  -->
                <div id="restaurant-wrapper" style="position: relative; width: 47%; max-width: 47%;" class="video-thumbnail-wrapper">
                    <img id="restaurantThumb" src="https://wancomresource.s3.eu-west-3.amazonaws.com/pizzeriathumbnail.png" alt="restaurant miniature" style="width: 100%; cursor: pointer;">
                </div>
                <div id="agence-wrapper" style="position: relative; width: 47%; max-width: 47%;" class="video-thumbnail-wrapper">
                    <img id="agenceThumb" src="https://wancomresource.s3.eu-west-3.amazonaws.com/agencethumbnail.png" alt="Agence miniature" style="width: 100%; cursor: pointer;">
                </div>
                <div id="location-wrapper" style="position: relative; width: 47%; max-width: 47%;" class="video-thumbnail-wrapper">
                    <img id="locationVoitureThumb" src="https://wancomresource.s3.eu-west-3.amazonaws.com/locationvoiturethumbnail.png" alt="location de voiture miniature" style="width: 100%; cursor: pointer;">
                </div>
                <div id="directionnel-wrapper" style="position: relative; width: 47%; max-width: 47%;" class="video-thumbnail-wrapper">
                    <img id="directionnelThumb" src="https://wancomresource.s3.eu-west-3.amazonaws.com/directionnelthumbnail.png" alt="directionnel miniature" style="width: 100%; cursor: pointer;">
                </div>
            
            </div>
        </div>

        <div class="card graphCard">
            <h3 class="graphTitle">
                Faire appel à notre studio graphique
                <article class="priceDiv">
                    <span> 200€  </span>
                </article>
            </h3>

            
            <!-- <div class="lottie" id="graph"></div> -->
            <div class="iframeContainer">
                <iframe src="https://lottie.host/embed/aa4f9c69-ffd3-4da8-b177-428916bc7614/kRuLeUkydM.json" id="graphLottie"></iframe>
            </div>
            
            <p class="beforePayment">
                Envoyez-nous vos éléments, notre studio vous recontacte et s'occupe de tout !
                
                <mat-form-field appearance="outline" class="graphsInput" style="width: 100%; margin-top: 20px; margin-bottom: -35px; margin-bottom: 0px;">
                    <mat-label>Réservez dès à présent vos créations</mat-label>
                    <span matSuffix (click)="addValue()" class="inputBtn material-icons">add</span>
                    <span matPrefix (click)="removeValue()" class="inputBtn material-icons">remove</span>
                    
                    <input
                    matInput
                    type="number"
                    placeholder="Nom"
                    class="spotFormControl"
                    [(ngModel)]="spotFormControl.value"
                    />
                </mat-form-field>
            </p>
            
        </div>
    </div>
</div>
<button mat-stroked-button color="secondary" class="backBtn" (click)="goBack()">Retour</button>

<article class="nextContainer" (click)="goToCart()">
    <div>
        <span class="screenCount">
            Continuer avec {{ spotFormControl.value }} création<span *ngIf="spotFormControl.value > 1">s</span>
        </span>
    </div>
    <span class="material-icons cartIcon">navigate_next</span>
</article>
